import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=171f657e"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=171f657e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports